module.exports = __webpack_public_path__ + "static/media/progress-active.84793dcb.svg";